/**
 * Created by xuchangxia on 2019/02/14.
 */
import config from '../config/download-app';
import { getCheckUaObject } from '../utils/common/base';

/**
 *  判断ua中是否有spiderList的值
 * @param {Array} spiderList
 */
export function isSpider(spiderList) {
  const ua = navigator.userAgent.toLowerCase();
  return Object.values(spiderList).some(value => ua.indexOf(value) > -1);
}

export function getURLParameter(name) {
  return decodeURIComponent((new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

// sem users
export function isSemUser(semList) {
  const refer = document.referrer.toLowerCase();
  const { keys } = Object;
  const semListArr = keys(semList);
  for (let i = 0; i < semListArr.length; i += 1) {
    const k = semListArr[i];
    const semV = semList[k];
    if (refer.indexOf(k)) {
      if (semV.refer) {
        return keys(semV.refer).every(ik => !refer.indexOf(semV.refer[ik]));
      }
      if (semV.params) {
        return keys(semV.params).every(jk => !getURLParameter(semV.params[jk]));
      }
      return true;
    }
  }
  return false;
}

export function getToday(separator) {
  const separatorN = separator || '';
  const nowDate = new Date();
  const noww = nowDate.getFullYear()
              + separatorN + (nowDate.getMonth() + 1) + separatorN + nowDate.getDate();
  return noww;
}

export function setLocalStorage(name, val) {
  return localStorage.setItem(name, val);
}

export function getLocalStorage(name) {
  return localStorage.getItem(name);
}

export function concatUrlParams(params) {
  let result = '?';
  Object.keys(params).forEach((k) => {
    if (typeof params[k] === 'object') {
      result += (`${k}=${encodeURIComponent(JSON.stringify(params[k]))}&`);
    } else {
      result += (`${k}=${encodeURIComponent(params[k])}&`);
    }
  });

  result = result.substr(0, result.length - 1);
  return result;
}

export function openApp(url) {
  const uaUtil = getCheckUaObject() || {};
  if (!url) {
    return;
  }
  if (uaUtil.openharmony) {
    // 鸿蒙暂不支持自定义页面跳转，统一跳首页
    window.location.href = 'openanjuke://app.anjuke.com/home/';
  } else if (uaUtil.weixin) {
    window.location.href = url;
  } else if (uaUtil.android) {
    const ifr = document.createElement('iframe');
    ifr.setAttribute('height', 0);
    ifr.setAttribute('width', 0);
    ifr.src = url;
    document.body.appendChild(ifr);
  } else if (uaUtil.ioshigh >= 9) { // ios系统版本>=9
    const ioshighurl = `${config.site.appInfo.iosHighUrl}scheme=${encodeURIComponent(url)}`;
    window.location.href = ioshighurl;
  } else {
    window.location = url;
  }
}

export function isSeoAndSpider() {
  const spiderList = ['bot', 'spider', 'yahoo'];
  const semList = {
    'baidu.com': {
      refer: ['baidu.com'],
    },
    'sogou.com': {
      refer: ['bill_cpc'],
    },
    'so.com': {
      params: ['pi'],
    },
    'haosou.com': {
      params: ['pi'],
    },
    '360.cn': {
      params: ['pi'],
    },
    'sm.cn': {
      params: ['pi'],
    },
  };
  const semUserKey = 'sem_user_key';
  // if it is spider or sem user,don't bind the click event
  if (isSpider(spiderList)) {
    return true;
  }
  if (isSemUser(semList)) {
    setLocalStorage(semUserKey, getToday('/'));
    return true;
  }
  if (getLocalStorage(semUserKey) === getToday('/')) return true;
  return false;
}

export function autoOpenAppThreeTimes(page) {
  const ajkAppWakeKey = 'ajk_app_wakeup';
  // only three times in one day
  let openHistory = getLocalStorage(ajkAppWakeKey);
  openHistory = openHistory ? JSON.parse(openHistory) : {};
  const today = getToday('/');
  let openTimes = 0;
  if (today === openHistory.timeStamp) {
    const openHistoryKeyArr = Object.keys(openHistory);
    for (let i = 0; i < openHistoryKeyArr.length; i += 1) {
      const key = openHistoryKeyArr[i];
      if (key !== 'timeStamp') {
        openTimes += openHistory[key];
        if (openTimes > 2) {
          return false;
        }
      }
    }
  }
  const newOpenHistory = Object.assign(openHistory, {
    timeStamp: today,
  });

  const curPageTime = newOpenHistory[page] || 0;
  newOpenHistory[page] = curPageTime + 1;
  setLocalStorage(ajkAppWakeKey, JSON.stringify(newOpenHistory));
  return true;
}

export function open(data) {
  if (isSeoAndSpider()) {
    return;
  }

  const appPage = data.apppage || '';
  let params = {};
  let sojRefer;

  if (data.page) {
    sojRefer = data.page + (data.refer ? (`_${data.refer}`) : '');
  }
  if (appPage === 'loupan') {
    params = {
      refer: sojRefer,
      extra_loupan_id: data.extra_loupan_id,
    };
    openApp(config.site.appInfo.loupanLink + concatUrlParams(params));
  } else if (appPage === 'housetype') {
    params = {
      refer: sojRefer,
      house_type_id: data.house_type_id,
      extra_loupan_id: data.extra_loupan_id,
    };
    openApp(config.site.appInfo.housetypeLink + concatUrlParams(params));
  } else if (appPage === 'home') {
    params = {
      refer: sojRefer,
    };
    openApp(config.site.appInfo.homeLink + concatUrlParams(params));
  } else if (data.openurl) {
    openApp(data.openurl);
  } else {
    params = {
      refer: sojRefer,
      city_id: data.city_id,
    };
    openApp(config.site.appInfo.loupanlistLink + concatUrlParams(params));
  }
}
